/**
 * 执行 getter，重置 this
 * @param formItem
 * @param target
 */
export const computeOption = <T>(formItem: T, target: any): T =>
    Object.keys(formItem).reduce((prev, key) => {
        const descriptor = Object.getOwnPropertyDescriptor(formItem, key)!;
        return {
            ...prev,
            [key]: descriptor.get
                ? descriptor.get.apply(target)
                : descriptor.value,
        };
    }, {}) as any;
